import * as types from '@/store/mutation-types';

const siteFields = [
  '*',
  'shafts.*',
  'shafts.type.*.*.*',
  'shafts.site_id.*',
  'shafts.site_id.company.*.*',
  'shafts.cover.*',
  'shafts.cone.*',
  'shafts.user_created.*',
  'shafts.user_created.user.*',
  'shafts.user_updated.*',
  'shafts.user_updated.user.*',
  'shafts.order_user.*',
  'shafts.order_user.user.*',
  'shafts.input_channel.*',
  'shafts.input_channel.diameter.*',
  'shafts.output_channel.*',
  'shafts.output_channel.diameter.*',
  'shafts.side_channels.*',
  'shafts.side_channels.diameter.*',
  'shafts.buildups.*',
  'shafts.buildups.type.*',
];

const getters = {
  sites: state => state.sites,
  selectedSite: state => state.selectedSite,
};

const actions = {
  async getSites({ commit, getters }) {
    try {
      const sites = this._vm.$directus.items('site');
      const sitesData = await sites.readByQuery({
        sort: 'name',
        fields: siteFields,
      });

      // sort by shaft update dates
      var arrSites = sitesData.data;
      arrSites.forEach(site => {
        if (!site.date_updated) site.date_updated = site.date_created;

        site.shafts.forEach(shaft => {
          if (
            shaft.user_updated &&
            shaft.user_updated.id === getters.user.id &&
            new Date(shaft.date_updated) > new Date(site.date_updated)
          )
            site.date_updated = shaft.date_updated;
        });
        site.shafts = site.shafts.sort(
          (a, b) => new Date(b.date_updated) - new Date(a.date_updated),
        );
      });
      arrSites = arrSites.sort(
        (a, b) => new Date(b.date_updated) - new Date(a.date_updated),
      );

      commit(types.SAVE_SITES, arrSites);
    } catch (error) {
      //console.error(error);
      commit(types.SHOW_ERROR, error.message);
    }
  },
  async addSite({ commit, dispatch }, payload) {
    try {
      const sites = this._vm.$directus.items('site');
      const site = await sites.createOne(payload);
      dispatch('getSites');
      return site;
    } catch (error) {
      //console.error(error);
      commit(types.SHOW_ERROR, error.message);
      throw error;
    }
  },
  async setSelectedSite({ commit }, payload) {
    commit(types.SAVE_SITE, payload);
  },
};

const mutations = {
  [types.SAVE_SITES](state, sites) {
    state.sites = sites;
  },
  [types.SAVE_SHAFT](state, shaft) {
    if (state.sites)
      state.sites.forEach(site => {
        if (site.shafts) {
          var index = site.shafts.findIndex(
            s => s && shaft && s.id === shaft.id,
          );
          if (index >= 0) {
            site.shafts.splice(index, 1);
            site.shafts.splice(0, 0, shaft);
          }
        }
      });
  },
  [types.SAVE_MY_SITES](state, sites) {
    state.sites = sites;
  },
  [types.SAVE_SITE](state, selectedSite) {
    state.selectedSite = selectedSite;
  },
};

const state = {
  sites: undefined,
  selectedSite: undefined,
};

export default {
  state,
  getters,
  actions,
  mutations,
};
